import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CSSModules from 'react-css-modules';
import cn from 'classnames';

import Card from '../../../Card';
import Icon from '../../../Icon';
import TextMessageForm from '../../../common/TextMessageForm';
import { ACTIONS } from '../../../../constants/strings';
import { COLORS } from '../../../../constants/styles';
import { COMPLAINT_TYPE } from '../../../../constants';
import { ALLOW_SOCIAL_CHAT_CREATION } from '../../../../constants/chat';
import { COMPLAINT_RESOLVE_ACTIONS as RESOLVE } from '../../../../constants/props';
import { IDS } from '../../../../constants/ids';
import styles from './styles.styl';

const ReportMenu = ({ type, appliedActions, formatMessage, id, onResolve }) => {
  const [isMessageFieldOpened, openMessageField] = useState(false);
  const checkStatus = buttonAction => {
    return appliedActions
      .map(action => get(action, 'actionName'), null)
      .includes(buttonAction);
  };

  const getCard = (text, icon, applied) => {
    return (
      <Card
        text={{ primary: text }}
        additionalContent={{
          left: (
            <Icon
              className="db mb1"
              name={icon}
              style={{ fill: COLORS.bluePrimary }}
            />
          ),
          right: (
            <If condition={applied}>
              <Icon
                className="db mb1"
                name="check"
                style={{ fill: COLORS.greenLime }}
              />
            </If>
          ),
        }}
      />
    );
  };

  const handleResolveActions = (actionType, message) => {
    const data = {
      apply_action: actionType,
      text_message: message,
      id,
    };
    onResolve(data);
  };

  return (
    <ul styleName="menu">
      <If condition={ALLOW_SOCIAL_CHAT_CREATION}>
        <li
          id={IDS.REPORTS.SEND_MESSAGE_OPTION}
          styleName="item"
          onClick={() => openMessageField(!isMessageFieldOpened)}
        >
          {getCard(
            formatMessage(ACTIONS.chat.sendMessage),
            'comment',
            checkStatus(RESOLVE.SEND_MESSAGE),
          )}
        </li>

        <If condition={isMessageFieldOpened}>
          <TextMessageForm
            onSendMessage={message =>
              handleResolveActions(RESOLVE.SEND_MESSAGE, message)
            }
            formatMessage={formatMessage}
            onClose={() => openMessageField(false)}
          />
        </If>
      </If>
      <If condition={type !== COMPLAINT_TYPE.COMMUNITY}>
        <li
          styleName={cn('item', {
            'item--disabled': checkStatus(RESOLVE.REMOVE_AUTHOR),
          })}
          onClick={() => handleResolveActions(RESOLVE.REMOVE_AUTHOR)}
          id={IDS.REPORTS.REMOVE_AUTHOR_OPTION}
        >
          {getCard(
            formatMessage({
              id: 'community.menu.removeMemberFromCommunity',
            }),
            'remove-from-community',
            checkStatus(RESOLVE.REMOVE_AUTHOR),
          )}
        </li>
        <li
          styleName={cn('item', {
            'item--disabled': checkStatus(RESOLVE.DESTROY_REPORTABLE),
          })}
          onClick={() => handleResolveActions(RESOLVE.DESTROY_REPORTABLE)}
          id={IDS.REPORTS.DESTROY_REPORTABLE_OPTION}
        >
          {getCard(
            formatMessage({
              id:
                type === COMPLAINT_TYPE.POST
                  ? 'community.postMenu.deletePost'
                  : 'community.commentMenu.deleteComment',
            }),
            'remove',
            checkStatus(RESOLVE.DESTROY_REPORTABLE),
          )}
        </li>
      </If>
    </ul>
  );
};

ReportMenu.propTypes = {
  type: PropTypes.string,
  id: PropTypes.number,
  appliedActions: PropTypes.array,
  formatMessage: PropTypes.func,
  onResolve: PropTypes.func,
};

export default CSSModules(ReportMenu, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportDetails/ReportMenu.jsx